import {observer} from "mobx-react";
import {ScanDocumentListItemDto, ScanStatusDto} from "../../../api/sea";
import {convertDocumentType, convertScanStatus} from "../../../api";
import {authStore, seaDocumentArchiveStore, seaDocumentDetailStore} from "../../../store";
import {ScanDetailData} from "./ScanDetailData";
import {dateFormat} from "../../../utils";


const falsyStates = [
    ScanStatusDto.COMPLETE,
    ScanStatusDto.STACK_COMPLETE,
    ScanStatusDto.BAD_SCAN,
]
const hours12InMs = 12 * 60 * 60 * 1000; // 43200000 ms


function isItemReadyForArchive(item: ScanDocumentListItemDto): boolean {
    const {status, lastModifiedDate} = item

    if (!status || falsyStates.indexOf(status) !== -1) {
        return false
    }
    const now = new Date()

    const modifiedDate = lastModifiedDate ? new Date(lastModifiedDate) : new Date()

    return Math.abs(now.getTime() - modifiedDate.getTime()) >= hours12InMs
}

const ArchiveCell = observer(function ArchiveCell({
                                                      item
                                                  }: {
    item: ScanDocumentListItemDto
}) {
    return <td
        onClick={e => e.stopPropagation()}
    ><input
        type={"checkbox"}
        checked={seaDocumentArchiveStore.selected(item)}
        onChange={e => {
            seaDocumentArchiveStore.toggle(item, e.currentTarget.checked)
        }}
        disabled={!isItemReadyForArchive(item)}
    /></td>
})

const ExpandableRow = observer(function ExpandableRow({
                                                          item,
                                                          expanded,
                                                          onClick
                                                      }: {
    item: ScanDocumentListItemDto
    expanded: boolean
    onClick: () => void
}) {
    const scanDateFormatted = dateFormat(item.scanDate || item.lastModifiedDate);
    return <>
        <tr
            className={`link`}
            onClick={() => onClick()}
        >
            {authStore.hasRole('SCAN_ADAPTER_ARCHIVE_DOCUMENT') && <ArchiveCell item={item}/>}
            <td title={scanDateFormatted}>{scanDateFormatted}</td>
            <td title={item.stackId}>{item.stackId}</td>
            <td title={item.recordId}>{item.recordId}</td>
            <td title={item.documentId}>{item.documentId}</td>
            <td title={item.scanCode}>{item.scanCode}</td>
            <td title={item.vin}>{item.vin}</td>
            <td title={convertDocumentType(item.documentType)}>{convertDocumentType(item.documentType)}</td>
            <td title={`${item.position}`}>{item.position}</td>
            <td title={convertScanStatus(item.status)}>{convertScanStatus(item.status)}</td>
        </tr>
        {expanded && <tr>
            <td colSpan={9}>
                {
                    seaDocumentDetailStore.loading ?
                        <div
                            style={{display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '3em'}}>
                            <div className={"button is-loading"} style={{border: "none", background: 'none'}}></div>
                        </div>
                        : <ScanDetailData/>
                }
            </td>
        </tr>}
    </>
})

export {
    ExpandableRow
}
